import React from 'react'
import { CardDetailsType } from '..'
import cn from 'classnames'

const ResultsUi: React.FC<{
  cards: CardDetailsType[]
  onRender: (item: CardDetailsType, idx: number) => React.ReactNode
  className?: string
}> = ({ cards, onRender, children, className = '' }) => {
  return (
    <div className={cn('see-all-grid mb-3', className)}>
      {children}
      {!!cards.length &&
        cards.map((card, idx) => {
          return onRender(card, idx)
        })}
    </div>
  )
}

export default ResultsUi
